import { OAuthService } from "vue-components-library";

import { HttpClient } from "@/App/services/HttpClient";
import { HttpErrorParser } from "@/App/services/HttpErrorParser";
import { clearStorage, setItemInLocalStorage, Storage } from "@/App/services/LocalStorage";
import { AUTH_ENDPOINTS } from "@/Login/config";
import { AuthorizationToken, IUser, LoginRequestBody, LoginResponse } from "@/Login/services";
import { AxiosError } from "axios";

export const StorageKeys = {
  token: "jwt",
  user: "user",
};

export default {
  async login(request: LoginRequestBody): Promise<LoginResponse> {
    let tokenResponse;
    try {
      tokenResponse = await HttpClient.post(AUTH_ENDPOINTS.SIGNIN, {
        ...request,
        twiageClient: "ems",
        platform: "web",
      });

      return this.resolveUserByToken(tokenResponse);
    } catch (error) {
      throw HttpErrorParser.parse(error as AxiosError);
    }
  },

  async loginByToken(token: string) {
    try {
      const tokenResponse = await OAuthService.setHttpClient(HttpClient)
        .setSigninUrl(AUTH_ENDPOINTS.OAUTH_SIGNIN)
        .loginByToken(token);

      return this.resolveUserByToken(tokenResponse);
    } catch (error) {
      throw HttpErrorParser.parse(error as AxiosError);
    }
  },

  async resolveUserByToken(tokenResponse: AuthorizationToken) {
    try {
      setItemInLocalStorage({ key: StorageKeys.token, value: tokenResponse.token });
      const user = await HttpClient.get(AUTH_ENDPOINTS.ME);
      setItemInLocalStorage({ key: StorageKeys.user, value: user });
      return { authorizationToken: tokenResponse, user };
    } catch (error) {
      clearStorage();
      throw HttpErrorParser.parse(error as AxiosError);
    }
  },

  getToken(): string | null {
    return Storage.getItem(StorageKeys.token);
  },

  async logout() {
    await HttpClient.post(AUTH_ENDPOINTS.SIGNOUT);
  },

  getUser(): IUser | null {
    const storedUser = Storage.getItem(StorageKeys.user);
    return storedUser ? JSON.parse(storedUser) : null;
  },
};
